import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import AppStore from '@v4/store/appStore'
import { useMediaQuery, useTheme } from '@material-ui/core'
import useStyles from './Banner4.styled'

export const useBanner4 = props => {
	const autoHeight = AppStore.useStoreState(state => state.general.autoHeight)
	const { metaData } = props
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
	const classes = useStyles({ ...props, autoHeight, isMobile })

	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.image })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	const isMobileImage = isMobile && !!metaData.mobileImage?.image

	const image = isMobileImage ? metaData.mobileImage : metaData.image

	const isBackground = metaData.mobileImagePosition?.isBackgroundImage

	const isImageExist = !!image?.image

	return [
		{
			classes,
			image,
			direction: isMobile
				? metaData.mobileImagePosition?.contentDirection()
				: metaData.imagePosition?.contentDirection(),
			withBgImage: isMobile && isBackground && isImageExist,
			withDesktopImage: isImageExist,
			withMobileImage: isMobile && !isBackground && isImageExist,
			isMobile,

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextConfig: metaData.buttonText?.config,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonTextEditable,
			buttonTextKey: metaData.buttonText?.tierKey,
		},
		{
			handleImageClick,
			handleTextClick,
			handleButtonClick,
			handleTextChange,
			handleButtonTextChange,
		},
	]
}
